import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { buildAppRoutes } from '@/app/router/routes';
/**
 * 应用路由实例：采用数据路由（createBrowserRouter）。
 * loader 一律在渲染前执行，登录校验等重定向不会产生中间空帧，
 * 懒加载与错误降级由根布局统一兜住。
 */
const appRouter = createBrowserRouter(buildAppRoutes());
/** 应用路由装配点，后续业务页面按项目路由继续嵌套扩展。 */
export function AppRouter() {
    return _jsx(RouterProvider, { router: appRouter });
}
